import React, { useEffect, useState } from 'react';
import { Menu } from 'lucide-react';
import { motion } from 'framer-motion';
interface NavbarProps {
  onStartQuiz: () => void;
}
export function Navbar({
  onStartQuiz
}: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-200 h-[52px] md:h-[72px] flex items-center ${scrolled ? 'bg-primary/95 backdrop-blur-md shadow-sm' : 'bg-transparent'}`} data-id="element-125">
      <div className="max-w-[1400px] w-full mx-auto px-5 md:px-12 lg:px-[72px] flex items-center justify-between" data-id="element-126">
        <a href="#" className="block" data-id="element-127">
          <img src="https://cdn.magicpatterns.com/uploads/3W8L2kirpjPTRAsEjJh9yk/ChatGPT_Image_28_abr_2026,_13_06_05_(1).png" alt="FitConecta" className="h-8 md:h-10 w-auto" data-id="element-128" />
        </a>

        <div className="hidden lg:flex items-center space-x-8" data-id="element-129">
          {['Cómo funciona', 'Planes', 'FAQ'].map(item => <a key={item} href={`#${item.toLowerCase().replace(' ', '-')}`} className="text-sm font-medium text-text-secondary hover:text-accent transition-colors" data-id="element-130">
              {item}
            </a>)}
        </div>

        <div className="flex items-center space-x-3" data-id="element-131">
          <motion.button whileTap={{
          scale: 0.96
        }} className="bg-dark text-white uppercase tracking-[0.1em] text-[10px] md:text-[12px] font-bold py-2.5 px-5 md:px-7 rounded-full hover:bg-dark/90 transition-all" onClick={onStartQuiz} data-id="element-132">
            HACER TEST
          </motion.button>
          <button className="lg:hidden w-8 h-8 flex items-center justify-center text-text-primary" data-id="element-133">
            <Menu className="w-5 h-5" data-id="element-134" />
          </button>
        </div>
      </div>
    </nav>;
}